import { IonIcon } from '@ionic/react';
import { shieldCheckmarkOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { RELEASE_CLAUSE_INDIVIDUAL_PROTECTION_DAYS } from '@/appConfig';
import { formatCountdown } from '../../../utils/time';

const PROTECTION_MS = RELEASE_CLAUSE_INDIVIDUAL_PROTECTION_DAYS * 24 * 60 * 60 * 1000;

interface PlayerReleaseClauseChipProps {
  releaseClause: number;
  individuallyProtected: boolean;
  weeklyWindowProtected: boolean;
  signedAt: string;
}

export const PlayerReleaseClauseChip = ({
  releaseClause,
  individuallyProtected,
  weeklyWindowProtected,
  signedAt,
}: PlayerReleaseClauseChipProps) => {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    if (!individuallyProtected) return;
    const interval = setInterval(() => setNowMs(Date.now()), 1000);
    return () => clearInterval(interval);
  }, [individuallyProtected]);

  if (individuallyProtected) {
    const msRemaining = new Date(signedAt).getTime() + PROTECTION_MS - nowMs;
    const label = msRemaining > 0 ? formatCountdown(msRemaining) : '0d';
    return (
      <div
        className="inline-flex items-center gap-1 whitespace-nowrap text-amber-600"
        data-testid="release-clause-chip-individual"
      >
        <IonIcon icon={shieldCheckmarkOutline} className="text-sm" />
        <span>{label}</span>
      </div>
    );
  }

  if (weeklyWindowProtected) {
    return (
      <div
        className="inline-flex items-center gap-1 whitespace-nowrap text-amber-600"
        data-testid="release-clause-chip-window"
      >
        <IonIcon icon={shieldCheckmarkOutline} className="text-sm" />
        <span>Jornada</span>
      </div>
    );
  }

  return (
    <div
      className="whitespace-nowrap font-heading font-bold text-[var(--fc-navy)]"
      data-testid="release-clause-chip-amount"
    >
      {releaseClause.toLocaleString('es-ES')}€
    </div>
  );
};
